<template>
  <component :is="component" :data="data" v-if="component" />
</template>
<script>
export default {
  name: "DynamicLink",
  props: ["data", "type"],
  data() {
    return {
      component: null
    }
  },
  computed: {
    loader() {
      if (!this.type) {
        return null
      }
      return () => import(`../templates/${this.type}`)
    }
  },
  watch: {
    type: {
      async handler() {
        try {
          await this.loader()
          this.component = () => this.loader()
        } catch (e) {
          this.component = () => import("../templates/default")
        }
      },
      immediate: true
    }
  }
}
</script>
